export const getSimpleSelectOptions = (items) => items.map((item) => ({
  value: item?.id,
  label: item?.name,
}));
